module.exports = __webpack_public_path__ + "media/images/league-5-b68227e041a41e7754e8f2c12b363f40.jpg";